import React from "react";

const ContentRow = ({children}) => {
	return (
		<div className="flex flex-row w-full space-x-4">
			{children}
		</div>
	);
};

export default ContentRow;
